import "react-phone-number-input/style.css";

import { ReactElement } from "react";
import PhoneInput from "react-phone-number-input";

import Input, { IInputElementProps, InputProps } from "../Input";

function PhoneNumberInput(
  props: InputProps<HTMLInputElement, string | null>
): ReactElement {
  return <Input InputComponent={BasePhoneNumberInput} {...props} />;
}

function BasePhoneNumberInput(
  props: IInputElementProps<HTMLInputElement, string | null>
) {
  const {
    input: { value, onChange, ...inputRest },
    meta,
    ref: _,
    ...rest
  } = props;

  return (
    <PhoneInput
      {...rest}
      {...inputRest}
      value={value}
      onChange={onChange}
      defaultCountry={"US"}
      initialValueFormat={"national"}
      sx={{
        paddingX: "12px",
        "& .PhoneInputInput": {
          paddingLeft: "8px",
          background: "transparent",
          border: "none"
        }
      }}
    />
  );
}

export default PhoneNumberInput;
